import React, { useEffect, useState } from "react";
import Chip from "@mui/material/Chip";
import {
  Done as IconVerified,
  ThumbDownAlt as IconReject,
  Edit as IconEdit,
} from "@mui/icons-material";
import { withSnackbar } from "notistack";

import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import TxtBox from "components/Custom/TxtBox";

import {
  API_CONFIG,
  CONFIG,
  CRM_LEAD_STATUS,
  DOC_UPLOAD_STATUS,
  NOTIFY,
} from "common/config";
import { COMMON_JS } from "common/scripts";
import { ERRORS, LABELS, SUCCESS, WARNINGS } from "common/lables";
import { CRM_APIs } from "apihandlers/crm";
import { AUTH_APIs } from "apihandlers/auth";
import { IconButton, Tooltip } from "@mui/material";
import Btn from "components/Custom/Btn";

interface defaultProps {}

const Approvals = (props: any) => {
  const { selectedRow, onClose } = props;
  const [loading, setLoading] = useState<boolean>(true);

  const onRowSave = async (row) => {
    const args = {
      id: -1,
      crmLeadId: selectedRow.id,
      comments: "comments", // todo: hard coded
    };
    setRows(null);
    const res: any = await CRM_APIs.manageCrmLeadApproval(args);
    console.log("onRowSave: ", row, res);
    if (res.status === 200) {
      COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
      getRows();
    } else {
      COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    }
  };

  const [column, setColumn] = useState<any>([
    {
      key: "approvalLevel",
      name: "Approve Level",
      type: "text",
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
    },
    {
      key: "approvalUserType",
      name: "User Type",
      width: "30%",
      editable: false,
      sortable: false,
      align: "center",
    },
    {
      key: "comments",
      type: "text",
      name: "Comments",
      width: "50%",
      editable: true,
      sortable: true,
      align: "center",
    },
    {
      key: "options",
      name: "Options",
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      renderCell: ({ row }: any) => {
        return (
          <div className="options">
            <Tooltip title={LABELS.SAVE} placement="bottom">
              <IconButton className="iconBtn" onClick={() => onRowSave(row)}>
                <IconEdit />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ]);
  const [rows, setRows] = useState<any>(null);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const manageCrmLeadDoc = async (
    fileId,
    docId,
    status = DOC_UPLOAD_STATUS.UPLOADED,
    id = null
  ) => {
    const args = {
      id: id || -1,
      crmLeadId: selectedRow.id,
      docId: docId,
      documentStatus: status,
      fileId,
    };
    CRM_APIs.manageCrmLeadDocument(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        getRows();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const getRows = async () => {
    try {
      const args = {};
      setRows(null);
      const res: any = await CRM_APIs.getCrmApprovals(args);
      const { status, response } = res;
      if (status === 200) {
        const list = res.response.records;
        setRows(list);
        setLoading(false);
        getCrmLeadApprovals(list);
      }
    } catch (error) {
      console.error("getCrmApprovals:", error);
    }
  };

  const getCrmLeadApprovals = async (list: any) => {
    const args = { crmLeadId: selectedRow.id };
    const res: any = await CRM_APIs.getCrmLeadApprovals(args);
    console.log("getCrmLeadApprovals:", res.response.records);
    if (res.status === 200) {
      if (res.response.records.length > 0) {
        const recs = res.response.records;
        for (let i = 0; i < list.length; i++) {
          if (list[i].isApprovalMandatory) {
            list[i].approvalUserType = (
              <span className="red">{list[i].approvalUserType + " *"}</span>
            );
          }
          const approvals = recs.filter(
            (r: any) => r.approvalUserTypeId === list[i].approvalUserTypeId
          );
          console.log("approvals: ", approvals);
          const commentObj =
            approvals.length > 0 ? approvals[approvals.length - 1] : {};
          list[i].comments = commentObj.comments || "";
          // list[i].files = (
          //   <div className="flexRow">
          //     <div style={{ width: "40%" }}>
          //       <TxtBox
          //         type={"file"}
          //         id={"uploadFile-" + i}
          //         accept="image/*,.pdf"
          //         onChange={(e) => onUploadFile(e, list[i])}
          //       />
          //     </div>
          //     <div
          //       style={{
          //         marginLeft: 10,
          //         width: "60%",
          //         overflow: "auto",
          //         display: "flex",
          //       }}
          //     >
          //       {docFiles.map((d: any) => {
          //         const fileUrl = API_CONFIG.STATIC_URL + d.path;
          //         return (
          //           <img
          //             onClick={() => {
          //               window.open(fileUrl, "_blank");
          //             }}
          //             src={fileUrl}
          //             width={"auto"}
          //             height={50}
          //             style={{ marginRight: 5 }}
          //           />
          //         );
          //       })}
          //     </div>
          //   </div>
          // );
          // const isVerified =
          //   docFile.documentStatus &&
          //   docFile.documentStatus === DOC_UPLOAD_STATUS.UPLOADED;
          // const isRejected =
          //   docFile.documentStatus &&
          //   docFile.documentStatus === DOC_UPLOAD_STATUS.UPLOADED;
          // list[i].status = (
          //   <div
          //     className="flexRow"
          //     style={{ margin: "auto", display: "block" }}
          //   >
          //     {docFile.documentStatus && (
          //       <Chip
          //         label={docFile.documentStatus}
          //         color={"success"}
          //         disabled={true}
          //         style={{ marginLeft: "10px" }}
          //         className={
          //           "chipBtn " +
          //           (docFile.documentStatus === DOC_UPLOAD_STATUS.VERIFIED
          //             ? "green"
          //             : docFile.documentStatus === DOC_UPLOAD_STATUS.REJECTED
          //             ? "red"
          //             : "limeGreen")
          //         }
          //       />
          //     )}
          //     {isVerified && (
          //       <Chip
          //         label={DOC_UPLOAD_STATUS.VERIFIED}
          //         disabled={false}
          //         clickable={true}
          //         icon={<IconVerified />}
          //         style={{ marginLeft: "10px" }}
          //         className={"chipBtn"}
          //         onClick={() => {
          //           manageCrmLeadDoc(
          //             docFile.fileId,
          //             list[i].id,
          //             DOC_UPLOAD_STATUS.VERIFIED,
          //             docFile.id
          //           );
          //         }}
          //       />
          //     )}
          //     {isRejected && (
          //       <Chip
          //         label={DOC_UPLOAD_STATUS.REJECTED}
          //         disabled={false}
          //         clickable={true}
          //         icon={<IconReject />}
          //         style={{ marginLeft: "10px" }}
          //         className={"chipBtn"}
          //         onClick={() => {
          //           manageCrmLeadDoc(
          //             docFile.fileId,
          //             list[i].id,
          //             DOC_UPLOAD_STATUS.REJECTED,
          //             docFile.id
          //           );
          //         }}
          //       />
          //     )}
          //   </div>
          // );
        }
      }
    }
    setRows(list);
    setLoading(false);
  };

  const onApprove = async () => {
    try {
      const args = {
        crmLeadId: selectedRow.id,
        crmLeadName: selectedRow.crmLeadName,
        activeStatus: "true",
        crmLeadStatus: CRM_LEAD_STATUS.APPROVALS,
      };
      const res = await CRM_APIs.manageCrmLeadProfile(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
    } catch (error) {
      console.error("onConverted: ", error);
    }
  };

  return (
    <React.Fragment>
      {rows ? (
        <>
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={column}
            rows={rows}
            exportOption={false}
            newRowOption={false}
            onReload={getRows}
          />
          <div
            className="flexColumn"
            style={{
              alignItems: "center",
              marginTop: "2rem",
            }}
          >
            <div
              className="flexRow"
              style={{ width: "20%", justifyContent: "center" }}
            >
              <Btn
                text={CRM_LEAD_STATUS.APPROVALS}
                style={{ width: "100%" }}
                onClick={onApprove}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="flexRowCenter">
          <Loader />
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Approvals);
